import { useEffect, useState } from "react";
import ReactGA from "react-ga4";

// Global CSS
import "./assets/scss/Global.scss";

// Routing
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Firebase
import { auth } from "src/firebase";
import { onAuthStateChanged } from "firebase/auth";

// State
import { useRecipes } from "src/hooks/useRecipes";
import { useTags } from "src/hooks/useTags";

// Context/provider
import { TagStateProvider } from "src/providers/TagStateProvider";

// Page components
import ListPage from "src/components/organisms/listPage/ListPage";
import LoginPage from "src/components/organisms/loginPage/LoginPage";
import RecipeSingle from "src/components/organisms/recipeSingle/RecipeSingle";
import NotFound from "src/components/organisms/notFound/NotFound";

// Components
import PageTop from "src/components/molecules/pageTop/PageTop";
import Loader from "src/components/atoms/loader/Loader";

const GA_MEASUREMENT_ID: string =
  process.env.REACT_APP_GA_MEASUREMENT_ID ?? "G-B4693HRTNX";

const App = () => {
  const { error: recipesError, isLoading: recipesLoading } = useRecipes();
  const { error: tagsError, isLoading: tagsLoading } = useTags();
  const [authLoading, setAuthLoading] = useState(true);
  const [isLoggedIn, setLoggedIn] = useState(false);

  // listen for log in/outs
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setAuthLoading(false);
      setLoggedIn(!!user);
    });

    return unsubscribe;
  }, []);

  useEffect(() => {
    if (!ReactGA.isInitialized) {
      ReactGA.initialize(GA_MEASUREMENT_ID);
    }
  }, []);
  if (authLoading || recipesLoading || tagsLoading)
    return (
      <div className="container container--page">
        <Loader />
      </div>
    );

  if (recipesError || tagsError)
    return (
      <div className="container container--page">
        <h1>Error</h1>
      </div>
    );

  return (
    <TagStateProvider>
      {/* <Helmet>
        <title>Recipe finder</title>
        <meta name="description" content="A collection of favourite recipes" />
        <meta name="theme-color" content="#3b85a4" />
      </Helmet> */}

      <Router>
        {!isLoggedIn ? (
          <LoginPage auth={auth} />
        ) : (
          <>
            <PageTop />
            <Routes>
              <Route path="/" element={<ListPage />} />
              <Route path="/recipe/:slug" element={<RecipeSingle />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </>
        )}
      </Router>
    </TagStateProvider>
  );
};

export default App;
